<template>
    <div>
        <CardHeader :title="title" :description="description">
            <template v-slot:header-right><slot name="header-right"></slot></template>
        </CardHeader>

        <CardBody>
            <slot />
        </CardBody>
    </div>
</template>

<script>
import SectionCardHeader from './SectionCardHeader.vue';
import SectionCardBody from './SectionCardBody.vue';

export default {
    props: {
        title: { required: true },
        description: { required: false },
    },
    components: {
        CardHeader: SectionCardHeader,
        CardBody: SectionCardBody,
    },
};
</script>
